import { PopoverProps } from '@blueprintjs/core';
import { Select as BlueprintSelect, ItemPredicate, ItemRenderer } from '@blueprintjs/select';
import { PropsWithChildren } from 'react';
import './Select.scss';

export interface ISelectProps<T> {
  className?: string;
  popoverProps?: Partial<Omit<PopoverProps, 'content' | 'defaultIsOpen' | 'fill' | 'renderTarget'>>;
  items: T[];
  filterable?: boolean;
  activeItem?: T | null;
  itemRenderer: ItemRenderer<T>;
  onItemSelect: (item: T) => void;
}

export type { ItemPredicate, ItemRenderer };

function Select<T>(props: PropsWithChildren<ISelectProps<T>>) {
  return <BlueprintSelect {...props} />;
}

export default Select;
